import { useState } from 'react';
import { RequireAuth } from '@/shared/auth/RequireAuth';
import { ToastProvider } from '@/app/providers/ToastProvider';
import { AuthProvider } from '@/app/providers/AuthProvider';
import { TenantScopeProvider } from '@/app/providers/TenantScopeProvider';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { CommandPalette } from './CommandPalette';
import { PlanModal } from './PlanModal';
import { usePlanRefresh } from './usePlanRefresh';
import { BusinessTypeGate } from './BusinessTypeGate';
import { useZoomResizeDispatch } from '@/shared/hooks/useZoomResizeDispatch';

function ShellInner() {
  const [collapsed, setCollapsed] = useState(false);
  const [planOpen, setPlanOpen] = useState(false);
  usePlanRefresh();
  useZoomResizeDispatch();

  return (
    <>
      <Sidebar collapsed={collapsed} onUpgrade={() => setPlanOpen(true)} />
      <Header
        collapsed={collapsed}
        onToggleCollapsed={() => setCollapsed((x) => !x)}
        onOpenPlanModal={() => setPlanOpen(true)}
      />
      <main className={`ts-main${collapsed ? ' collapsed' : ''}`}>
        <BusinessTypeGate />
      </main>
      <CommandPalette onUpgrade={() => setPlanOpen(true)} />
      <PlanModal open={planOpen} onClose={() => setPlanOpen(false)} />
    </>
  );
}

export function ShellLayout() {
  return (
    <AuthProvider>
      <ToastProvider>
        <RequireAuth>
          <TenantScopeProvider>
            <ShellInner />
          </TenantScopeProvider>
        </RequireAuth>
      </ToastProvider>
    </AuthProvider>
  );
}
